import { ECountryCode } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';
import type { IContact } from 'src/interfaces/contact';
import { getDocumentId } from 'src/utils/mongo/getDocumentId';
import { CapitalizeNames } from 'src/utils/capitalize';
import type { TSelectItem } from 'src/components/Search/components/types';
import type { TContactFormValues } from './types';
import { defaultContactFormValues } from './types';
import { CONTACT_DEFAULT_AVATAR } from '../constants/images';

const mapContactUsersToSelectItems = (
    users: IContact['users'] | undefined
): TSelectItem[] => {
    if (!users?.length) return [];

    return users.map((userRef) => {
        if (typeof userRef === 'string') {
            return { value: userRef, label: userRef };
        }

        return {
            value: userRef._id,
            label: userRef.name ? CapitalizeNames(userRef.name) : userRef._id,
        };
    });
};

export function contactToFormValues(
    contact: IContact | null | undefined
): Partial<TContactFormValues> {
    if (!contact) return defaultContactFormValues;

    return {
        name: contact.name ?? '',
        email: contact.email ?? '',
        phone: contact.phone ?? '',
        secondaryPhone: contact.secondaryPhone ?? '',
        countryCode: contact.countryCode ?? ECountryCode.Mexico,
        secondaryCountryCode:
            contact.secondaryCountryCode ?? ECountryCode.Mexico,
        employment: contact.employment ?? '',
        notes: contact.notes ?? '',
        store: getDocumentId(contact.store) ?? '',
        users: mapContactUsersToSelectItems(contact.users),
        image: contact.image ?? CONTACT_DEFAULT_AVATAR,
        tags: contact.tags ?? [],
    };
}
